import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'

import { fetchObjectives, addObjective } from '../actions/objectives'
import { fetchArqueos } from '../actions/arqueos'
import { fetchCustomers } from '../actions/customers'
import ObjectiveList from '../components/ObjectiveList'
import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'

import ObjectivesFilterForm from '../forms/ObjectivesFilterForm'

import '../styles/ObjectivesAdminView.css'

class ObjectivesView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      filterOpen: true,
      createModalOpen: false,
      createCustomer: '',
      createYear: new Date().getFullYear(),
      createSubmitting: false,
      createError: null
    }
  }

  componentDidMount() {
    const today = new Date();
    const currentYear = today.getFullYear();

    const yearStart = new Date(currentYear, 0, 1);
    const formattedStartDate =
      `${yearStart.getFullYear()}-${(yearStart.getMonth() + 1).toString().padStart(2, '0')}-${yearStart.getDate().toString().padStart(2, '0')}`;
    const yearEnd = new Date(currentYear + 1, 0, 0);
    const formattedEndDate =
      `${yearEnd.getFullYear()}-${(yearEnd.getMonth() + 1).toString().padStart(2, '0')}-${yearEnd.getDate().toString().padStart(2, '0')}`;

    this.props.fetchObjectives('', today)
    this.props.fetchArqueos('', '', formattedStartDate, formattedEndDate, '');
    this.props.fetchCustomers();
  }

  handleCreateSubmit() {
    const { createCustomer, createYear } = this.state;

    if (!createCustomer) {
      this.setState({ createError: 'Selecciona un cliente' });
      return;
    }

    this.setState({ createSubmitting: true, createError: null });

    this.props.addObjective({
      Customer: createCustomer,
      Year: createYear,
      TimeStamp: new Date(Date.UTC(createYear, 0, 1))
    }).then(response => {
      if (response.error) {
        this.setState({
          createSubmitting: false,
          createError: response.error.message || 'Error al crear el objetivo'
        });
      } else {
        this.setState({
          createModalOpen: false,
          createCustomer: '',
          createYear: new Date().getFullYear(),
          createSubmitting: false,
          createError: null
        });
        this.props.fetchObjectives('', new Date());
      }
    }).catch(() => {
      this.setState({
        createSubmitting: false,
        createError: 'Error al crear el objetivo'
      });
    });
  }

  calculateTotalKPILay() {

    let kpiLay = 0;
    let totalPack = 0;
    let totalLay = 0;

    {
      this.props.arqueos.map((arqueo) => {
        totalLay += arqueo.Items.VWLAY
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiLay = (totalLay / totalPack) * 100

    return kpiLay
  }

  calculateTotalKPIGo() {

    let kpiGo = 0;
    let totalPack = 0;
    let totalGo = 0;

    {
      this.props.arqueos.map((arqueo) => {
        totalGo += arqueo.Items.VWGO
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiGo = (totalGo / totalPack) * 100

    return kpiGo
  }

  calculateTotalCrossSale() {

    let kpiCross = 0;
    let totalPack = 0;
    let totalLay = 0;
    let totalGo = 0;

    {
      this.props.arqueos.map((arqueo) => {
        totalLay += arqueo.Items.VWLAY
        totalGo += arqueo.Items.VWGO
        totalPack += arqueo.Items.VWPACK
      }
      )
    }

    kpiCross = ((totalGo + totalLay) / totalPack) * 100

    return kpiCross
  }

  calculateTotalObjective(objectives) {

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const weeks = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6'];

    let totalObjectives = 0;

    objectives.forEach(objective => {
      {
        months.map((month) => {
          weeks.map(week => (
            totalObjectives += objective[month][week]

          ))
        }
        )
      }
    });

    return totalObjectives
  }

  calculateTotalReal() {

    let totalReal = 0;

    {
      this.props.arqueos.map((arqueo) => {
        if (arqueo.ContractType != "SALE") {
          totalReal += this.calculatePriceWithoutTax(arqueo.SalesTotal, arqueo.Tax)
        }
      }
      )
    }

    return totalReal
  }

  calculatePriceWithoutTax(priceWithTax, taxRate) {
    // Convert tax rate from percentage to decimal
    const taxMultiplier = 1 + taxRate / 100;

    // Calculate price without tax and round to two decimal places
    const priceWithoutTax = (priceWithTax / taxMultiplier).toFixed(2);

    // Convert the string back to a number
    return parseFloat(priceWithoutTax);
  }

  progressBar(actual, objective) {

    const percentage = objective > 0 ? (actual / objective) * 100 : 0;
    const barWidth = Math.min(percentage, 100);

    let color = "warning"

    if (percentage < 50) {
      color = "danger"
    } else if (percentage >= 100) {
      color = "success"
    }

    return (
      <div className="obj-progress-container">
        <div className={`obj-progress-bar ${color}`} style={{ width: `${barWidth}%` }}></div>
        <div className="obj-progress-percentage">{percentage.toFixed(2)}%</div>
      </div>
    );
  }

  renderKPIs() {
    const { arqueos, objectives, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!objectives || loading || !arqueos) {
      return <LoadingProgress />
    }

    if (objectives.length === 0) {
      return (
        <div className="obj-admin-empty">
          <i className="fas fa-bullseye"></i>
          <p>No hay objetivos disponibles para mostrar. Por favor, crea nuevos objetivos para el año actual.</p>
        </div>
      );
    }

    const totalReal = this.calculateTotalReal()
    const totalObjective = this.calculateTotalObjective(objectives)
    const percentage = totalObjective > 0 ? (totalReal / totalObjective) * 100 : 0
    const kpiLay = this.calculateTotalKPILay()
    const kpiGo = this.calculateTotalKPIGo()
    const crossSale = this.calculateTotalCrossSale()
    const date = (new Date(objectives[0].TimeStamp)).getFullYear()

    return (
      <>
        <div className="obj-kpi-row">
          <div className="obj-kpi-card real">
            <div className="kpi-icon"><i className="fas fa-coins"></i></div>
            <div className="kpi-content">
              <div className="kpi-value">{totalReal.toFixed(2)} €</div>
              <div className="kpi-label">Real {date}</div>
            </div>
          </div>
          <div className="obj-kpi-card objective">
            <div className="kpi-icon"><i className="fas fa-bullseye"></i></div>
            <div className="kpi-content">
              <div className="kpi-value">{totalObjective.toFixed(2)} €</div>
              <div className="kpi-label">Objetivo {date}</div>
            </div>
          </div>
          <div className="obj-kpi-card percentage">
            <div className="kpi-icon"><i className="fas fa-chart-line"></i></div>
            <div className="kpi-content">
              <div className="kpi-value">{percentage.toFixed(2)}%</div>
              <div className="kpi-label">Progreso</div>
            </div>
          </div>
        </div>

        <div className="obj-total-card">
          <div className="obj-total-header">
            <i className="fas fa-globe"></i> Resumen Global
          </div>
          <div className="obj-total-labels">
            <div className="obj-total-col col-customer">Cliente</div>
            <div className="obj-total-col col-year">Año</div>
            <div className="obj-total-col col-real">Real</div>
            <div className="obj-total-col col-objective">Objetivo</div>
            <div className="obj-total-col col-progress">Progreso</div>
            <div className="obj-total-col col-status" style={{width: '100px'}}>KPI Lay</div>
            <div className="obj-total-col col-status" style={{width: '100px'}}>KPI Go</div>
            <div className="obj-total-col col-status" style={{width: '120px'}}>Venta Cruzada</div>
          </div>
          <div className="obj-total-row">
            <div className="obj-total-col col-customer">Todos los clientes</div>
            <div className="obj-total-col col-year">{date}</div>
            <div className="obj-total-col col-real">{totalReal.toFixed(2)} €</div>
            <div className="obj-total-col col-objective">{totalObjective.toFixed(2)} €</div>
            <div className="obj-total-col col-progress">{this.progressBar(totalReal, totalObjective)}</div>
            <div className="obj-total-col col-status" style={{width: '100px', textAlign: 'center'}}>{isNaN(kpiLay) ? '—' : kpiLay.toFixed(2) + '%'}</div>
            <div className="obj-total-col col-status" style={{width: '100px', textAlign: 'center'}}>{isNaN(kpiGo) ? '—' : kpiGo.toFixed(2) + '%'}</div>
            <div className="obj-total-col col-status" style={{width: '120px', textAlign: 'center'}}>{this.progressBar(crossSale, 100)}</div>
          </div>
        </div>
      </>
    )
  }

  renderObjectives() {
    const { arqueos, objectives, error, loading } = this.props

    if (error) {
      return (<ErrorMessage message={error.message} />)
    }

    if (!objectives || loading || !arqueos) {
      return <LoadingProgress />
    }

    if (objectives.length === 0) {
      return null
    }

    return (
      <ObjectiveList objectives={objectives} arqueos={arqueos} />
    )
  }

  render() {
    const { role, customers } = this.props
    const { createModalOpen, createCustomer, createYear, createSubmitting, createError } = this.state

    return (
      <div className="objectives-admin-view">
        {/* Header */}
        <div className="obj-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-bullseye mr-1"></i>
                Objetivos de Venta
              </h1>
            </div>
            {role === 'ADMIN' &&
              <div className="header-actions">
                <button
                  className="obj-admin-btn primary"
                  onClick={() => this.setState({ createModalOpen: true, createError: null })}
                >
                  <i className="fas fa-plus"></i>
                  <span>Crear Objetivos</span>
                </button>
              </div>
            }
          </div>
        </div>

        {/* Create Objective Modal */}
        <Modal isOpen={createModalOpen} toggle={() => this.setState({ createModalOpen: false })} className="obj-create-modal">
          <ModalHeader toggle={() => this.setState({ createModalOpen: false })} className="obj-create-modal-header">
            <i className="fas fa-plus-circle"></i> Crear Objetivos
          </ModalHeader>
          <ModalBody className="obj-create-modal-body">
            {createError && <div className="alert alert-danger">{createError}</div>}
            <div className="obj-create-field">
              <label>Cliente</label>
              <select
                className="form-control"
                value={createCustomer}
                onChange={e => this.setState({ createCustomer: e.target.value })}
              >
                <option value="">Selecciona un cliente...</option>
                {customers &&
                  customers
                    .sort((a, b) => a.Fullname.localeCompare(b.Fullname))
                    .map(c => (
                      <option value={c._id} key={c._id}>{c.Fullname}</option>
                    ))}
              </select>
            </div>
            <div className="obj-create-field">
              <label>Año</label>
              <select
                className="form-control"
                value={createYear}
                onChange={e => this.setState({ createYear: parseInt(e.target.value) })}
              >
                {[...Array(10)].map((_, i) => {
                  const year = new Date().getFullYear() - i;
                  return <option key={year} value={year}>{year}</option>;
                })}
              </select>
            </div>
          </ModalBody>
          <ModalFooter className="obj-create-modal-footer">
            <button
              className="obj-admin-btn primary"
              onClick={() => this.handleCreateSubmit()}
              disabled={createSubmitting}
            >
              {createSubmitting
                ? <><i className="fas fa-spinner fa-spin"></i> Guardando...</>
                : <><i className="fas fa-save"></i> Guardar</>
              }
            </button>
            <button
              className="obj-admin-btn secondary"
              onClick={() => this.setState({ createModalOpen: false })}
            >
              Cancelar
            </button>
          </ModalFooter>
        </Modal>

        {/* Collapsible Filter */}
        <div className="obj-admin-filter-card">
          <div
            className="obj-admin-filter-header"
            onClick={() => this.setState({ filterOpen: !this.state.filterOpen })}
          >
            <h3><i className="fas fa-filter"></i> Filtros</h3>
            <i className={`fas fa-chevron-down toggle-icon ${this.state.filterOpen ? 'open' : ''}`}></i>
          </div>
          {this.state.filterOpen && (
            <div className="obj-admin-filter-body">
              <ObjectivesFilterForm />
            </div>
          )}
        </div>

        {/* KPI Cards + Total Summary */}
        {this.renderKPIs()}

        {/* Objectives List */}
        {this.renderObjectives()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  objectives: state.objectives.objectives,
  arqueos: state.arqueos.arqueos,
  customers: state.customers.customers,
  error: state.objectives.error,
  loading: state.arqueos.loading,
  role: state.auth.role,
  form: state.form
})

const mapDispatchToProps = dispatch => ({
  fetchObjectives: bindActionCreators(fetchObjectives, dispatch),
  fetchArqueos: bindActionCreators(fetchArqueos, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  addObjective: bindActionCreators(addObjective, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ObjectivesView)

